import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { PlanMainService } from '../plan/service/plan-main.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-contact-bar',
  templateUrl: './contact-bar.component.html',
  styleUrls: ['./contact-bar.component.css']
})
export class ContactBarComponent implements OnInit {
  @Output() setLoader: any = new EventEmitter<any>();
  constructor(private _planmainService: PlanMainService) {}

  ngOnInit() {}

  downloadPDF(filename: string) {
    this.setLoader.emit(true);
    this._planmainService.downloadManual(filename).subscribe(
      res => {
        if (res) {
          const blob = new Blob([res], { type: 'application/pdf' });
          saveAs(blob, filename + '.pdf');
        }
        setTimeout(() => {
          this.setLoader.emit(false);
        }, 500);
      },
      err => {
        this.setLoader.emit(false);
        console.error('download manual fail');
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/contact-bar/contact-bar.component.ts